<template>
    <div id="app" :class="[isImmerse && 'has-top']" :style="{ 'opacity': !pageLoading ? 1 : 0 }">
        <!-- 顶部分享按钮 -->

        <div class="top" v-if="isImmerse" :style="{ 'top': statusBarHeight + 'px' }">
            <button class="back-btn" @click="back"></button>
            <button class="share-btn" @click="share"></button>
        </div>

        <video ref="videoOne" playsinline webkit-playsinline x5-playsinline x5-video-player-type="h5"
            x5-video-player-fullscreen="true" class="person-wapper" src="./assets/img/ai-pf/xp-waiting.mp4" autoplay
            muted loop>
        </video>
        <video ref="videoTwo" playsinline webkit-playsinline x5-playsinline x5-video-player-type="h5"
            x5-video-player-fullscreen="true" class="person-wapper" v-show="AutoplayIng"
            src="./assets/img/ai-pf/xp-speaking.mp4" autoplay muted loop>
        </video>

        <!--        <div class="music" :style="{'top': statusBarHeight+'px'}">-->
        <!--            <button class="music-btn" :class="!musicFlag && 'off'" @touchstart="switchMusic"></button>-->
        <audio id="music" autoplay :data-play="musicFlag" loop="loop" src=""></audio>
        <!--        </div>-->
        <!--        <base-component :baseData="baseData" v-if="baseData"></base-component>-->

        <div>
            <transition enter-active-class="animated fadeInUpBig" leave-active-class="animated fadeOutDownBig ">
                <div class="detailPop" v-show="isToastShow">
                    <div
                        :class="[toastContent.toastType == 11 || toastContent.toastType == 12 ? 'popWrapper2' : 'popWrapper']">
                        <div class="contentPopCls" :style="[toastContent.closeColor === 'white' ? { padding: 0 } : {}]">
                            <div class="topsOperate">
                                <div class="popName">{{ toastContent.list.name }}</div>
                                <div class="close" @click="onCloseToast">
                                    <!-- <img src="./assets/img/close.png" alt="关闭" class="closeImg" -->
                                        v-if="!toastContent.closeColor || toastContent.closeColor === 'black'">
                                    <!-- <img src="./assets/img/closeWhite.png" alt="关闭" class="closeImg" v-else> -->
                                </div>
                            </div>
                            <div :class="[(!toastContent.closeColor || toastContent.closeColor === 'black') || toastContent.toastType === 9 || toastContent.toastType === 10 ? 'contentTips' : 'contentTips2']"
                                id="contentTips" ref="contentTips" @scroll="handleScroll(toastContent.toastType)">
                                <div class="popGlobalText" v-html="toastContent.list.content"
                                    v-if="toastContent.toastType == 0">
                                    {{ toastContent.list.content }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--        <div class="maskWarp" :style="`display:${maskShowStatus?'block':'none'}`"></div>-->

        <!-- 提示框，不带操作按钮 -->
        <div class="loadMask" v-if="!!maskData">
            <div :class="maskData.type === 11 ? 'maskContent SmallmaskContent' : 'maskContent'">
                <p v-html="(maskData.text && maskData.text) || '加载中...'"></p>
                <div class="btn_wrapper" v-if="maskData.type === 11">
                    <div class="cancel" @click="onCancel">取消</div>
                    <div class="ok" @click="goSet">确认</div>
                </div>
            </div>
        </div>

        <keep-alive :include="cacheList">
            <router-view :style="{ 'padding-top': statusBarHeight + 'px' }" ref="childPage" />
        </keep-alive>

    </div>
</template>

<script>
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import { getAudioAccess } from '@/utils/AudioSDK.js';
import { mapState, mapActions, mapMutations } from "vuex";
import { getmicrophone } from "@/utils/utils";
import { config, XMLY, XMplayer } from "@xmly-fem/web-jssdk";

export default {
    data() {
        return {
            musicFlag: true,
            baseData: null,
            statusBarHeight: 0,
            thisPage: "home",
            show: false,
            formPage: "",
            path: "home",
            oContent: {},
            timeCount: 0,
            timer: null,
            cacheList: ["home"],
            remTimer: null
        };
    },
    computed: {
        ...mapState(["isApp", "versionSize", "userinfo", "pageLoading", "shareData", "isImmerse", "maskData", "globalDuration", "isClearTimer", "toastContent", "isToastShow", "readNewsId", "isClearInitTimer", "maskShowStatus", "tourSelectData", "robotConfig", "isAudioShow", "xmly",]),
        ...mapState('audio', ["xPlayer", "fPlayer", "audioCurrentIndex", "audioList"]),
        ...mapState(["chatLoading", "AutoplayIng"]),
    },
    components: {},
    watch: {
        // globalDuration(value) {
        //     if (value == 0) {
        //         this.timeCount = 0;
        //         this.timer = setInterval(this.inter, 1000);
        //     }
        // },

        isClearTimer(value) {
            console.info("isClearTimer", value);
            if (value) {
                clearInterval(this.timer);
            } else {
                this.timeCount = 0;
                this.timer = setInterval(this.inter, 1000);
            }
        },

        "$route"(to, from) {
            this.thisPage = to.name;
            this.formPage = from.name;
            let referrer = document.referrer;
            console.info("referrer", referrer);
            if (from.name == "blank" && to.name == "home") {

            }
            // if(referrer!==''&&from.name!=='blank'&&!this.isClearInitTimer){
            //     this.getInterData(0)
            // }
            if (this.formPage == null) {
                // this.$router.replace('/')
            }
            this.setPageLoadingAsync(true);
            // document.querySelector('.loading-wrap').style.display = 'block'

            // if(this.maskData && this.maskData.type != 1 && this.maskData.type != 2 && this.maskData.type != 3) {
            //     this.setMaskDataAsync(null)
            // }
        }

    },
    created() {
        // this.getRobotConfig();
        getAudioAccess()
        this.setXmly(new XMLY());
        let _this = this;
        getmicrophone(
            function () {
                // 麦克风授权允许
                _this.setPermitUseMicrophone(true);
                _this.setMicrophoneErrorData("");
            },
            function (errorName) {
                // 麦克风授权不允许,错误名称
                console.log("error麦克风授权不允许", errorName);
                _this.setMicrophoneErrorData(errorName);
                _this.setPermitUseMicrophone(false);
            }
        );
        this.remTimer = setInterval(this.checkRem, 1000);
    },
    mounted() {
        // window.addEventListener("popstate", function(e) { 
        //     alert("我监听到了浏览器的返回按钮事件啦");//根据⾃⼰的需求实现⾃⼰的功能
        // }, false);

        // if (window.history && window.history.pushState) 
        // { 
        //     history.pushState(null, null, document.URL); 
        //     window.addEventListener('popstate', function(e) { 
        //         alert("我监听到了浏览器的返回按钮事件啦");//根据⾃⼰的需求实现⾃⼰的功能
        //     }, false); 
        // }

        this.path = this.$route.name;
        this.appFlagAsync(COVERAPP.Attribute.isApp());
        // this.getInterData()
        let _this = this;
        let isFromSecondFloor = false;
        // cio.initLoad({activeId: "", applicationId: "coverzxrobot"});
        this.getUserInfoAsync();
        // !this.isApp && COVER.isWapHidden()

        if (this.isApp) {
            let version = COVERAPP.Attribute.appVersion();
            let versionNum = version.split(".");
            let versionSize = parseInt(versionNum.join(""));
            this.setVersionSizeAsync(versionSize);
            if (this.versionSize >= 570) {
                COVERAPP.Method.getWebInfo({
                    callback(ret) {
                        let data = typeof ret == "object".toLowerCase() ? JSON.stringify(ret) : ret;
                        if (JSON.parse(data).showType == 1) {
                            _this.setIsImmerseAsync(true);
                            let statusBarHeight = JSON.parse(data).statusBarHeight;
                            if (COVERAPP.Attribute.isAndroid()) {
                                let devicePixelRatio = (typeof window.devicePixelRatio).toLowerCase() == "number" ? window.devicePixelRatio : 0;
                                _this.statusBarHeight = devicePixelRatio ? statusBarHeight / devicePixelRatio : statusBarHeight;
                            } else {
                                _this.statusBarHeight = statusBarHeight;
                            }
                        }
                        if (JSON.parse(data).isFromSecondFloor == 1) {
                            isFromSecondFloor = true;
                            COVERAPP.Method.webContentLoadFinish();
                        }
                    }
                });
            }
        }
        // _this.onWatch();
        _this.setPageLoadingAsync(false);
        clearTimeout(timeoutIds);
        _this.autoPlayVideo();
    },
    destroyed() {
        clearInterval(this.timer);
        clearInterval(this.remTimer);
    },
    methods: {
        ...mapActions([
            "setPageLoadingAsync",
            "setIsImmerseAsync",
            "appFlagAsync",
            "setVersionSizeAsync",
            "setMaskDataAsync",
            "getUserInfoAsync",
            "getHotTopic", "queryComment", "setNoInfo", "getTourData", "queryPoke", "getSceneCommon",
            "getRobotConfig",
        ]),
        ...mapMutations([
            "contactDisData",
            "setGlobalDuration",
            "setToastShow",
            "setClearTimer",
            "setInputBlur",
            "setTagsList",
            "setTourSelectData",
            "setSingleTags",
            "setXmly",
            "setPermitUseMicrophone",
            "setMicrophoneErrorData",
        ]),
        getInterData(time) {
            let that = this;
            this.initTimer = setTimeout(function () {
                that.setNoInfo();
            }, time);
        },
        onWatch() {
            let that = this;
            that.timeCount = 0;
            that.timer = setInterval(that.inter, 1000);
        },

        inter() {
            let that = this;
            window.addEventListener("touchstart", function () {
                that.timeCount = 0;
                that.setGlobalDuration(0);
            }, false);
            that.timeCount++;
            console.log(that.timeCount)
            if (that.timeCount > 10) {
                // that.getHotTopic();
                // that.getSceneCommon()
                that.$refs.childPage && that.$refs.childPage.onPagePoke && that.$refs.childPage.onPagePoke()

                clearInterval(that.timer);
                that.timeCount = 0;
                that.setGlobalDuration(11);
            }
        },


        onBack() {

            if (this.thisPage != "home") {
                this.$router.back(-1);
            } else {
                COVERAPP.Method.Back();
            }
        },
        musicPlay() {
            let _this = this;
            let music = document.getElementById("music");
            if (this.musicFlag) {
                music.play();
            }
            // 微信自动播放
            document.addEventListener("WeixinJSBridgeReady", () => {
                if (this.musicFlag) {
                    music.play();
                }
            }, false);
            // 兼容其他不自动播放的情况
            document.addEventListener("touchstart", () => {
                if (this.musicFlag && this.thisPage == "home") {
                    music.play();
                }
            }, false);
        },
        switchMusic(e) {
            let music = document.getElementById("music");
            this.musicFlag && e.stopPropagation();
            this.musicFlag = !this.musicFlag;
            if (this.musicFlag) {
                music.play();
            } else {
                music.pause();
            }
        },
        back() {

            if (this.formPage == null || this.thisPage != "home") {
                this.$router.back(-1);
            } else {
                COVERAPP.Method.Back();
            }
        },
        share() {
            let _this = this;
            let ShareData = JSON.parse(JSON.stringify(this.shareData));
            ShareData.callback = function (ret) {
                // COVER.track(_this.aid, 'share', '分享')
                cio.track(1, "share", {});
            };
            if (!this.isImmerse) {
                COVER.share(ShareData);
            }
        },
        onCloseToast() {
            const { toastType } = this.toastContent;

            if (toastType == 1 || toastType == 2) {
                this.getTourData({ payload: {} });
            }
            if (toastType === 7) {
                this.setClearTimer(true);
                this.contactDisData([{ content: { right: true, tips: "" } }]);
                this.queryComment({ payload: { newsId: this.readNewsId } });
            }
            this.setToastShow(false);
        },
        oTourSelect(name, value, id, type, child, select) {
            console.info("select", !!select);
            const { selectType } = this.toastContent;
            let array = [];
            if (selectType == "single") {
                this.tourSelectData.map((item, ix) => {
                    if (item.name === name && !item.select) {
                        item.select = true;
                        array.push(item);
                    } else {
                        item.select = false;
                        array.push(item);
                    }
                });
                this.setSingleTags([{ name: name, value: value, select: !!select }]);
            } else {

                this.tourSelectData.map((item, ix) => {
                    if (item.name === name && !item.select) {
                        item.select = true;
                        array.push(item);
                    } else if (item.name === name && item.select) {
                        item.select = false;
                        array.push(item);
                    } else {
                        array.push(item);
                    }
                });
                this.setTagsList([{ name: name, value: value, select: !!select }]);

            }

            this.setTourSelectData(array);


        },
        handleScroll(type) {
            this.isShouldRefresh = false
            if (type === 9 || type === 10) {
                //变量scrollTop是滚动条滚动时，距离顶部的距离
                let scrollTop = this.$refs.contentTips.scrollTop
                //变量windowHeight是可视区的高度
                let windowHeight = this.$refs.contentTips.clientHeight
                //变量scrollHeight是滚动条的总高度
                let scrollHeight = this.$refs.contentTips.scrollHeight
                //滚动条到底部的条件
                if (scrollTop + windowHeight + 10 >= scrollHeight) {
                    //到了这个就可以进行业务逻辑加载后台数据了
                    console.log("到了底部")
                    this.isShouldRefresh = true

                }

            }

        },
        visible() {
            document.addEventListener("visibilitychange", () => {
                if (document.hidden && this.isAudioShow) {
                    console.log('熄屏熄屏')
                    // this.xPlayer && this.xPlayer.play()

                } else if (this.isAudioShow) {
                    console.log('亮屏亮屏')
                    // setTimeout(() => {
                    console.log(this.audioList)
                    let playList = []
                    this.audioList.forEach((item) => {
                        playList.push(item.id)
                    })
                    this.setXPlayer(new XMplayer({ playlist: playList }))
                    this.xPlayer && this.xPlayer.play()
                    // }, 2000)
                }
            });
        },
        onCancel() {
            this.setMaskDataAsync(null);
        },
        goSet() {
            this.setMaskDataAsync(null);
        },
        checkRem() {
            const docEl = document.documentElement
            const fontSize = docEl.style.fontSize
            var psdWidth = 750
            var preFontSize = 100
            var rem = (docEl.clientWidth * preFontSize) / psdWidth

            if (fontSize !== rem + 'px') {
                docEl.style.fontSize = rem + 'px'
            }
        },
        // 自动播放检测
        autoPlayVideo() {
            const videoOne = this.$refs.videoOne; // 或 document.getElementById('myVideo')
            const videoTwo = this.$refs.videoTwo;

            // 尝试自动播放
            const playPromiseOne = videoOne.play();
            const playPromiseTwo = videoTwo.play();

            if (playPromiseOne !== undefined) {
                playPromiseOne
                    .then(() => {
                        console.log('✅ 视频静音自动播放成功');
                        // 可在此处显示“点击开启声音”按钮
                    })
                    .catch(err => {
                        console.warn('❌ 自动播放失败，等待用户交互:', err);
                        // 失败后绑定点击事件，让用户触发播放
                        this.bindClickToPlay(videoOne);
                    });
            }

            if (playPromiseTwo !== undefined) {
                playPromiseTwo
                    .then(() => {
                        console.log('✅ 视频静音自动播放成功');
                        // 可在此处显示“点击开启声音”按钮
                    })
                    .catch(err => {
                        console.warn('❌ 自动播放失败，等待用户交互:', err);
                        // 失败后绑定点击事件，让用户触发播放
                        this.bindClickToPlay(videoTwo);
                    });
            }
        },

        bindClickToPlay(video) {
            const handlePlay = () => {
                video.play().then(() => {
                    console.log('✅ 用户触发播放成功');
                    // 播放后可取消事件监听
                    document.removeEventListener('touchstart', handlePlay);
                    document.removeEventListener('click', handlePlay);
                }).catch(err => {
                    console.error('播放失败:', err);
                });
            };

            // 绑定 touchstart 和 click（移动端优先 touch）
            document.addEventListener('touchstart', handlePlay, { once: true });
            document.addEventListener('click', handlePlay, { once: true });
        },
    }
};
</script>

<style lang="less">
.maskWarp {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(255, 255, 255, 0);
    width: 100%;
    height: 100%;
    z-index: 1000;
}

.detailPop {
    font-size: .24rem;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    // background: rgba(0, 0, 0, .5);
    z-index: 1000;
    /*display: none;*/

    .popWrapper {
        max-width: 100%;
        min-width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10001;
    }

    .popWrapper2 {
        max-width: 100%;
        min-width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10001;
        height: 80%;
    }

    .popGlobalText {
        color: rgba(100, 103, 114, 1);
        font-size: .4rem;
        line-height: .7rem;

        .emoji {
            width: .6rem;
            height: .6rem;
        }
    }

    .contentPopCls {
        padding: 1.3rem .4rem 1rem .4rem;
        border-radius: .5rem .5rem 0 0;
        position: relative;
        // background: #fff;
        height: 100%;
        box-sizing: border-box;
    }

    .contentTips {
        font-size: .44rem;
        min-width: 6rem;
        line-height: .7rem;
        max-height: 11rem;
        overflow-y: scroll;
    }

    .contentTips2 {
        font-size: .44rem;
        min-width: 6rem;
        line-height: .7rem;
        height: 100%;
        overflow-y: scroll;
        border-radius: .5rem .5rem 0 0;

        .content {
            height: 100%;
        }
    }

    .topsOperate {
        height: 1.4rem;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        padding: 0 .5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .popName {
            font-size: .45rem;
            color: #171E32;
        }

    }

    .close {
        z-index: 1;

        .closeImg {
            width: .5rem;
            height: .5rem;
        }
    }
}

#app {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    /*padding: 9.2rem 0 1rem;*/
    margin: 0 auto;
    background-image: url('./assets/img/ai-pf/bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}


.back {
    position: fixed;
    bottom: 3.6rem;
    right: 0.2rem;
    z-index: 90;

    img {
        width: 1.4rem;
        height: 1.4rem;
    }
}


.has-top .wrapper {
    box-sizing: border-box;
}

.top {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    height: 1.046699rem;
    z-index: 20;
}


.back-btn {
    width: .692432rem;
    height: .724638rem;
    position: absolute;
    top: .305958rem;
    left: .587762rem;
    background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261id2iomlg5of41lp62k.png) no-repeat center top;
    background-size: 100% auto;
    z-index: 10;
}

.share-btn {
    width: .68438rem;
    height: .716586rem;
    position: absolute;
    top: .305958rem;
    right: .386473rem;
    background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm2717lf1elp1ff19un1b6k46.png) no-repeat center top;
    background-size: 100% auto;
    z-index: 10;
}

.music {
    position: fixed;
    top: 0;
    right: 1.545894rem;
    width: .716586rem;
    height: 1.1rem;
    z-index: 20;

    .music-btn {
        position: absolute;
        top: .305958rem;
        width: 100%;
        height: .764895rem;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27d0vvl96571ej71l4949.png) no-repeat center top;
        background-size: 100% 200%;

        &.off {
            background-position: center bottom;
        }
    }
}

.loadMask {
    /*position: fixed;*/
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 15;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;

    .maskContent {
        background: #fff;
        display: inline-block;
        border-radius: 0.12rem;
        font-size: 0.45rem;
        padding: 0.2rem;
    }

    .SmallmaskContent {
        width: 80%;
        font-size: 0.4rem;

        .NotAllowedError {
            display: flex;
            flex-direction: column;

            .title {
                text-align: center;
                font-weight: 800;
                margin: 0.2rem auto;
            }

            .des {
                text-indent: .426667rem;
            }
        }

        .btn_wrapper {
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0.2rem auto;


        }
    }
}

.person-wapper {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    object-fit: cover;

    // .person {
    //     position: absolute;
    //     left: 0;
    //     right:0;
    //     bottom: 0;
    //     width: 6.6rem;
    //     height: 10.64rem;
    //     margin: auto;
    //     background: url("./assets/img/home/person.png") left top / 100% 100% no-repeat;

    //     &.speak {
    //         background-image: url("./assets/img/home/xiaofeng.gif");
    //     }
    // }
}
</style>
